import { FC, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { environment } from "src/components/common/env";

const LinkBridge: FC = () => {

    const regex = /[a-z0-9]{5}/i;

    let { key } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        // Check if the key matches the structure of our keys
        if (regex.test(key)) {

            // Redirect to the api/{key} so the api handles the redirection flow
            const url = environment.apiBaseUrl + "/" + key;
            console.log("Redirecting to: " + url);
            window.location.href = url;
        }
        else {
            navigate("/status/404?l=" + window.location.href);
        }
    }, [key, navigate]);

    return (<>loading...</>);
}

export default LinkBridge;

